<template>
  <div id="page-status">
    <div v-if="searchResults && searchResults.length > 0" role="region" aria-labelledby="results" :key="statusKey">
      <hp5-heading v-if="total >= 20" size-selection="xs" id="results" tabindex="-1" tag-selection="h2"
        >Showing results {{ start }} - {{ end }} of {{ total }}</hp5-heading
      >
      <hp5-heading v-if="total < 20" size-selection="xs" id="results" tabindex="-1" tag-selection="h2"
        >Showing results {{ start }} - {{ total }} of {{ total }}</hp5-heading
      >
    </div>
  </div>
</template>
  
<script setup>
      const { pageSize, currentPage, searchResults } = useFCPModel()
      const start = computed(() => (currentPage.value - 1) * pageSize.value + 1)
      const total = computed(() => (searchResults.value ? searchResults.value.length : 0))
      const statusKey = ref(0)
  
      watch(currentPage, () => {
        statusKey.value += 1
      })
  
      const end = computed(() => {
        if (total.value < start.value + pageSize.value - 1) return total.value
        return start.value + pageSize.value - 1
      })

    onUpdated(() => {
      const digitalData = window.digitalData || []
      const event = 'results-info'
      digitalData.push({
        eventData: {
          totalResults: total.value,
          currentPage: currentPage.value,
          pageSize: pageSize.value,
          startsAt: start.value,
          endsAt: end.value,
        },
        event: event,
      })
    })

</script>
  
<style scoped>
  h2 {
    margin-top: 0px;
    margin-bottom: 0px;
  }
</style>